const FIInformation = {
  FI_NAME: "First Nations Bank of Canada",
  FI_APPLICATION_NAME: "smartOpen",
  FI_VAULT_NAME: "cart",
  FI_EMAIL: "https://fnbc.ca/AboutUs/ContactUs/",
  FI_TEL: "1-888-454-3622",
  FI_CONDITIONS: "https://www.fnbc.ca/Personal/Financial_Services_Terms.pdf",
  FI_PRIVACY: "https://fnbc.ca/AboutUs/OnlinePolicies/Privacy/PrivacyCode/",
  FI_SITE: "http://www.fnbc.ca/",
  FI_CONTACT_US: "http://www.fnbc.ca/",
  FI_OVERDRAFT_URL: "http://www.fnbc.ca/",
  FI_BENEFICIARY_URL: "http://www.fnbc.ca/",
  FI_SHARE_AMOUNT: "$5",
  FI_BUSINESS_SHARE_AMOUNT: "$50",
  FI_OVERDRAFT_DEFAULT_AMOUNT: "$100.00",
  FI_BOOK_APPOINTMENT: "http://www.fnbc.ca/",
};

export default FIInformation;
